import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, Events, ToastController, LoadingController, ViewController } from 'ionic-angular';
import { LoginService } from '../../providers/login-service/login-service';
import { ConfigureServiceProvider } from '../../providers/configure-service/configure-service';
import { EncrDecrServiceProvider } from '../../providers/encr-decr-service/encr-decr-service';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { DriveServiceProvider } from '../../providers/drive-service/drive-service';

const SuperUser = 0;
const ClientAdmin = 1;
const ShareUser = 2;
const toastDuration = 2000;
@Component({
  selector: 'page-user_management',
  templateUrl: 'user_management.html',
})

export class UserManagement {
  form: FormGroup = new FormGroup({});
  addMemberPopup: boolean = false;
  editMemberPopup: boolean = false;
  encryptedPwd: any;
  objUserDetails: any;
  userDetails: any = [];
  objEpcUserDetails: any = [];
  searchMember: string = '';
  userAccessType: any;
  emailIdEdit: any;
  access = "User"
  accessType = [
    { "key": "2", "value": "User" },
    { "key": "1", "value": "Admin" }]
  app_user: any;
  accessKey: string;
  duplicateMail: any = 0;
  alluserDetails: any = [];
  submitButtonDisable: boolean = true;
  regUserId: any;
  newUser = false;
  folderPropertiesUser: boolean = false;
  objSelectuserList: any = [];
  removedUserList: any = [];
  accessList = [];
  password: any;
  constructor(public loadingController: LoadingController, public viewCtrlSecurity: ViewController, private alertCtrl: AlertController, private fb: FormBuilder, public toastCtrl: ToastController, public driveServ: DriveServiceProvider, public navCtrl: NavController, public navParams: NavParams, public loginService: LoginService, public config: ConfigureServiceProvider, public events: Events, public toastController: ToastController, private EncrDecrService: EncrDecrServiceProvider, public configApiService: ConfigApiServiceProvider) {
    this.formGroupInitialize();
  }

  ngOnInit(): void {
    this.userDetails = this.driveServ.ObjCurrentAppUsers;
    this.objSelectuserList = JSON.stringify(this.navParams.get('shareUsers'));
    this.folderPropertiesUser = this.navParams.get('folderPropertiesUser');
    this.accessList = this.navParams.get('accessList');
    if (this.folderPropertiesUser == true) {
       this.updateShareUserStatus();
    }
    if (this.driveServ.adminAccess) {
      this.objUserDetails = this.userDetails.filter(obj => obj.email_id != this.driveServ.adminUserid)
    } else if (this.driveServ.clientAdminAccess) {
      this.objUserDetails = this.userDetails.filter(obj => obj.user_access_type != SuperUser && obj.app_user_id != this.config.getLoginUserID())
    }
  }

  addMemberToEpc() {
    this.duplicateMail = 0;
    this.addMemberPopup = true;
  }

  editMemberToEpc(editMember) {
    const objIdx = 0;
    this.editMemberPopup = true;
    this.editUser = true;
    this.emailIdEdit = editMember.email_id;
    this.regUserId = editMember.app_user_id;
    var accessTypeData = this.accessType.filter(obj => obj.key == editMember.user_access_type);
    this.access = accessTypeData[objIdx].value;
    this.userAccessType = accessTypeData[objIdx].key;
    this.password = editMember.password;
  }

  formGroupInitialize() {
    this.form = this.fb.group({
      "emailid": new FormControl('', [Validators.required, Validators.pattern(/^[\w]{1,}[\w.+-]{0,}@[\w-]{1,}([.][a-zA-Z]{2,}|[.][\w-]{2,}[.][a-zA-Z]{2,})$/)]),
      "password": new FormControl('', [Validators.required]),
      "confirmPassword": new FormControl('', [Validators.required]),
    }, {
      validator: this.ConfirmedValidator('password', 'confirmPassword')
    })
  }

  get f() {
    return this.form.controls;
  }

  ConfirmedValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmedValidator: true });
        this.submitButtonDisable = false;
      } else {
        matchingControl.setErrors(null);
      }
    }
  }

  getAccessType(accesstype) {
    this.userAccessType = accesstype.event;
  }

  onSubmitForm() {
    if (this.newUser == true) {
      this.submitButtonDisable = true;
      this.addNewUser();
    } else {
      this.updateUser();
    }
  }

  addNewUser() {
    if (this.form['status'] == 'VALID') {
      let arrayIndex = 0;
      this.userAccessType = this.userAccessType != undefined ? this.userAccessType : this.accessType[arrayIndex]['key']
      this.encryptedPwd = this.EncrDecrService.set('BETSYENC123$$', this.form['value']['confirmPassword']);
      let PostParams = Object.assign({}, this.configApiService.driveApi.createUser.params, {
        "targetepc": this.configApiService.currentDriveApp['app_code'],
        "emailid": this.form['value']['emailid'],
        "password": this.encryptedPwd,
        "access_type": this.userAccessType
      });
      this.configApiService.customRequest(this.configApiService.userLicenseAccessApi, PostParams, (resp) => {
        var format = resp['_POST_EPC_SETUP_USER_LICENSE_ACCESSResult']
        try {
          format = JSON.parse(format);
        } catch (e) {
        }
        this.listUsersAssignedToEpc();
      })
    } else {
      this.form.markAllAsTouched();
    }
  }

  listUsersAssignedToEpc() {
    let PullParams = {
      "targetepc": this.configApiService.currentDriveApp['app_code'],
    }
    let arrayIndex = 0;
    this.configApiService.customRequest(this.configApiService.fetchUserLicenceAccessApi, PullParams, (resp) => {
      this.userDetails = JSON.parse(resp["_POST_EPC_FETCH_USER_LICENSE_ACCESSResult"])
      this.driveServ.ObjCurrentAppUsers = this.userDetails;
      if (this.driveServ.adminAccess) {
        this.objUserDetails = this.userDetails.filter(obj => obj.email_id != this.driveServ.adminUserid)
      } else if (this.driveServ.clientAdminAccess) {
        this.objUserDetails = this.userDetails.filter(obj => obj.user_access_type != SuperUser && obj.user_access_type != ClientAdmin)
      }
      this.userAccessType = this.accessType[arrayIndex]['key'];
      this.onCancel();
    })
  }

  //********* Reset password Mail  *******//
  resetUserPassword(emailId, appUserId) {
    let newPassword = this.driveServ.generateString(5);
    this.encryptedPwd = this.EncrDecrService.set('BETSYENC123$$', newPassword);
    let PostParams = Object.assign({}, this.driveServ.configApiService.driveApi.updateUser.params, {
      "targetepc": this.driveServ.configApiService.currentDriveApp['app_code'],
    });
    let alert = this.alertCtrl.create({
      title: 'Do You Want Reset Your Password..?',
      buttons: [
        {
          text: 'Yes',
          handler: data => {
            this.driveServ.configApiService.customRequest(this.driveServ.configApiService.userLicenseAccessApi, PostParams, (resp) => {
              this.mailGenerate(emailId, newPassword);
            })
            alert.dismiss();
            return false
          }
        },
        {
          text: 'No',
          handler: data => {
            this.onCancel();
            alert.dismiss();
            return false
          }
        }
      ]
    });
    alert.present();

  }

  mailGenerate(toMail, newPassword) {
    let post_data = {};
    let mailBody = this.convertHtml(newPassword);
    let loginUserName = this.driveServ.configureService.getLoginData()["user"];
    post_data = { 'TOID': toMail, 'FROMID': loginUserName, 'BODY': mailBody, 'SUBJECT': 'Reset Password' };
    let objPushParams = Object.assign({}, this.driveServ.configApiService.driveApi.pushMailShareUser.params, post_data);
    this.driveServ.configApiService.pushRequest(objPushParams, (submitSucess) => {
      let alert = this.alertCtrl.create({
        title: 'Please check your Email,Will get your New Password!',
        buttons: [
          {
            text: 'Ok',
            handler: data => {
              this.onCancel();
              alert.dismiss();
              return false
            }
          }
        ]
      });
      alert.present();
    })
  }

  convertHtml(newPassword) {
    let bodyHtml: any = '';
    bodyHtml += '<div  style="width: 35%;"><table border="0" cellpadding="0" cellspacing="0" style="width: 100%;">' +
      '<thead border="0" cellpadding="0" cellspacing="0" width="78%"><tr><td>';
    bodyHtml += '<div style="margin: 12px;">Please </div>';
    bodyHtml += '</td></tr></thead><tbody style="padding: 12px;margin: 1px" border="0" cellpadding="0" cellspacing="0">' +
      '<tr border="0" cellpadding="0" cellspacing="0"><td border="0" cellpadding="0" cellspacing="0">' +
      '<div style="margin: 12px;display: flex;"><div style="margin-top: 25px;margin-left: 16px;"><span style="font-weight:bold">Your New Password is</span></div></div>' +
      '</td></tr><tr border="0" cellpadding="0" cellspacing="0"><td border="0" cellpadding="0" cellspacing="0"><div style="margin: 12px;">' +
      "<tr><td><div><p style='color: #333;font-size: 18px !important; font-style: italic;font-weight: bold;'>" + newPassword + "</p></div>" +
      '</div></td></tr></tbody><tfoot style="margin:1px;background-color: #cccccc;"><tr><td></td>' +
      '</tr></tfoot></table></div><br><br>' +
      '<div style="height: 50px;"><span style="margin-top:10px">regards,<br><span>' + this.driveServ.configureService.getLoginData()["user"] + '</span></span></div>';
    return bodyHtml;
  }

  removeMember(email_id) {
    let alert = this.alertCtrl.create({
      title: 'Are you sure, want to remove the member ?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Ok',
          handler: data => {
            let postParams = Object.assign({}, this.configApiService.driveApi.revokeUser.params, {
              "emailid": email_id,
              "targetepc": this.configApiService.currentDriveApp['app_code'],
            })
            this.configApiService.customRequest(this.configApiService.revokeUserLicenceAccessApi, postParams, (resp) => {
              const toast = this.toastController.create({
                message: 'Member removed!',
                duration: this.configApiService.toastDuration,
              });
              this.objUserDetails = this.objUserDetails.filter(
                (element, i) => element.email_id !== email_id);
              this.listUsersAssignedToEpc();
              toast.present();
            });
          }
        }
      ]
    });
    alert.present();
  }


  onCancel(selectionFlag = null) {
    this.addMemberPopup = false;
    this.editMemberPopup = false;
    if (selectionFlag != null) {
      this.submitButtonDisable = true;
    }
    this.formGroupInitialize();
  }

  searchMembers() {
    if (this.searchMember != "") {
      return this.searchMember;
    }
  }

  discardSearch(e) {
    this.searchMember = '';
  }

  getAccessEditType(event) {
    this.userAccessType = event.event
  }

  userCheck() {
    if (this.form['value']['emailid'] != "") {
      this.emailIdEdit = this.form['value']['emailid'];
      var rex = /^[\w]{1,}[\w.+-]{0,}@[\w-]{1,}([.][a-zA-Z]{2,}|[.][\w-]{2,}[.][a-zA-Z]{2,})$/
      if ((rex.test(this.emailIdEdit))) {
        this.listEpcAssignedToUser();
      } else {
        const toast = this.toastController.create({
          message: 'Enter the Vaild Email!',
          duration: this.configApiService.toastDuration,
        });
        toast.present();
      }

    } else {
      const toast = this.toastController.create({
        message: 'Enter the Email!',
        duration: this.configApiService.toastDuration,
      });
      toast.present();
    }
  }

  listEpcAssignedToUser() {
    let PullParams = {
      "emailid": this.form['value']['emailid'],
    }
    this.configApiService.customRequest(this.configApiService.fetchUserLicenceAccessApi, PullParams, (resp) => {
      this.objEpcUserDetails = JSON.parse(resp["_POST_EPC_FETCH_USER_LICENSE_ACCESSResult"]);
      const NO_MAIL_INDEX = -1;
      const arrayIndex = 0;
      this.duplicateMail = this.objEpcUserDetails.findIndex(elem => elem.email_id == this.form['value']['emailid']);
      if (this.duplicateMail != NO_MAIL_INDEX) {
        this.regUserId = this.objEpcUserDetails[this.duplicateMail]['app_user_id']
        this.newUser = false;
        this.editUser = false;
        let userIdx = this.objUserDetails.findIndex(users => users['email_id'] == this.form['value']['emailid']);
        if (userIdx != -1) {
          const toast = this.toastController.create({
            message: 'Email , is an Existing Member in this App',
            duration: this.configApiService.toastDuration
          });
          toast.present();
          this.addMemberPopup = false;
        } else {
          this.exixtingMail();
        }
      } else {
        this.newUser = true;
        this.submitButtonDisable = false;
        const toast = this.toastController.create({
          message: 'Email is not an Exisiting Member!',
          duration: this.configApiService.toastDuration
        });
        toast.present();
      }
    })
  }

  exixtingMail() {
    let alert = this.alertCtrl.create({
      title: 'Email , is an Existing Member, Confirm Acess to this App!',
      buttons: [
        {
          text: 'No',
          handler: data => {
            this.onCancel();
          }
        },
        {
          text: 'Yes',
          handler: data => {
            let userIdx = this.objUserDetails.findIndex(users => users['email_id'] == this.form['value']['emailid']);
            if (userIdx != -1) {
              this.addMemberPopup = false;
              this.submitButtonDisable = false;
            } else {
              this.submitButtonDisable = false;
            }
          }
        }
      ]

    });
    alert.present();
  }

  editUser: boolean = false;
  updateUser() {
    let arrayIndex = 0;
    this.userAccessType = this.userAccessType != undefined ? this.userAccessType : this.accessType[arrayIndex]['key']
    let PostParams = Object.assign({}, this.configApiService.driveApi.updateUser.params, {
      "targetepc": this.configApiService.currentDriveApp['app_code'],
      "emailid": this.emailIdEdit,
      'reg_user_id': this.regUserId,
      "access_type": this.userAccessType,
      "createuser": this.editUser == true ? 'UPDATE' : 'NO',
      "password": this.password
    });
    this.configApiService.customRequest(this.configApiService.userLicenseAccessApi, PostParams, (resp) => {
      var format = resp['_POST_EPC_SETUP_USER_LICENSE_ACCESSResult']
      try {
        format = JSON.parse(format);
      } catch (e) {
      }
      this.listUsersAssignedToEpc();
    })
  }

  checkedSelectedUsers() {
    if (JSON.parse(this.objSelectuserList).length != 0) {
      JSON.parse(this.objSelectuserList).forEach(element => {
        this.userDetails.map((item, i) => {
          if (item.email_id == element) {
            this.userDetails[i]['status'] = ShareUser;
            this.userDetails[i]['isDisableToggle'] = false;
          }
        })
      });
      this.accessList.forEach(element => {
        this.userDetails.map((item, i) => {
          if (item.email_id == element['email_id']) {
            const shareUser = 2
            this.userDetails[i]['Accesstatus'] = element['IsReadOnlyShare'] == 'NO' ? shareUser : 1
            this.userDetails[i]['watchAccesstatus'] = element['IsReadOnlyShare'] == 'NO' ? shareUser : 1
            this.userDetails[i]['isDisableToggle'] = true;
          }
        })
      });
    } else {
      this.userDetails.map((item, i) => {
        this.userDetails[i]['status'] = 1;
        this.userDetails[i]['Accesstatus'] = 1;
        this.userDetails[i]['watchAccesstatus'] = 1;
        this.userDetails[i]['isDisableToggle'] = true;

      })
    }
  }

  updateShareUserStatus() {
    if (this.objSelectuserList.length != 0) {
      this.userDetails.map((item, i) => {
        this.userDetails[i]['status'] = 1;
      })
      this.userDetails.map((item, i) => {
        this.userDetails[i]['Accesstatus'] = 1;
        this.userDetails[i]['isDisableToggle'] = true;
      })
      this.checkedSelectedUsers();
    } else {
      this.userDetails.map((item, i) => {
        this.userDetails[i]['status'] = 1;
        this.userDetails[i]['Accesstatus'] = 1;
        this.userDetails[i]['isDisableToggle'] = true;

      })
    }
  }

  selectUsers(toggle, email_id) {
    let accessList = {};
    var objSelectuserList = [];
    objSelectuserList = JSON.parse(this.objSelectuserList)
    if (toggle.checked == true) {
      let arrIdx = objSelectuserList.findIndex(item => item == email_id);
      let userIdx = this.userDetails.findIndex(item => item['email_id'] == email_id);
      this.userDetails[userIdx]['isDisableToggle'] = false;
      if (arrIdx == -1) {
        objSelectuserList.push(email_id);
        let arrIdx = objSelectuserList.findIndex(item => item == email_id);
        if (arrIdx != -1) {
          accessList['email_id'] = email_id,
          accessList['IsReadOnlyShare'] = 'YES';
          accessList['IsWatchAcessFlag'] = 'NO';
          this.accessList.push(accessList);
        }
        this.objSelectuserList = JSON.stringify(objSelectuserList)
      }
    } else {
      let arrIdx = objSelectuserList.findIndex(item => item == email_id);
      objSelectuserList.splice(arrIdx, 1);
      this.objSelectuserList = JSON.stringify(objSelectuserList)

    }
  }

  // getAccessUsers(toggle, email_id) {
  //   if (toggle.checked == true) {
  //     let arrIdx = this.accessList.findIndex(item => item['email_id'] == email_id);
  //     if (arrIdx != -1) {
  //       this.accessList[arrIdx]['IsReadOnlyShare'] = 'NO';
  //     }
  //   } 
  // }

  // getWatchUsers(toggle, email_id) {
  //   if (toggle.checked == true) {
  //     let arrIdx = this.accessList.findIndex(item => item['email_id'] == email_id);
  //     if (arrIdx != -1) {
  //       this.accessList[arrIdx]['IsWatchAcessFlag'] = 'YES';
  //     }
  //   } 
  // }

  pushSelectUser() {
    let pushData = {
      "selectUser": JSON.parse(this.objSelectuserList),
      "removeUser": this.removedUserList,
      "accessUser": this.accessList
    }
    this.viewCtrlSecurity.dismiss(pushData);
  }
}



// WEBPACK FOOTER //
// ./src/pages/user_management/user_management.ts